import classnames from 'classnames';
import { bool, func, node, oneOfType, string } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

import { tapFlashError, tapFlashSuccess } from '../../utils/flash';

export default class FileDownloader extends React.Component {
  constructor(props) {
    super(props);

    this.downloadFile = this.downloadFile.bind(this);
    this.link = React.createRef();
  }

  state = { loading: false };

  static getFileName(xhr) {
    const fileName = xhr.getResponseHeader('Content-Disposition').split('=')[1];
    return fileName && fileName.replace(/"/g, '');
  }

  downloadFile() {
    const { onGetFile, onFileDownloadSuccess } = this.props;
    this.setState({ loading: true });
    onGetFile()
      .then(({ data, name, request }) => {
        this.triggerSaveFile(data, name || FileDownloader.getFileName(request));
        onFileDownloadSuccess(data);
      })
      .then(tapFlashSuccess('File download successful'))
      .catch(tapFlashError())
      .finally(() => this.setState({ loading: false }));
  }

  triggerSaveFile(file, fileName) {
    if (!this.link.current) return; // The downloader was unmounted. The user is no longer interested.

    const url = URL.createObjectURL(file);
    this.link.current.href = url;
    this.link.current.download = fileName;
    this.link.current.click();
    URL.revokeObjectURL(url);
  }

  render() {
    const {
      tag: Tag,
      disabled,
      children,
      onGetFile,
      onFileDownloadSuccess,
      className,
      ...props
    } = this.props;
    const { loading } = this.state;

    const classes = classnames('cursor-pointer', className);
    return (
      <>
        <Tag
          disabled={disabled || loading}
          onClick={this.downloadFile}
          className={classes}
          {...props}
        >
          {children}
        </Tag>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a hidden download ref={this.link}>
          {children}
        </a>
      </>
    );
  }
}

FileDownloader.propTypes = {
  children: node,
  disabled: bool,
  onFileDownloadSuccess: func,
  onGetFile: func.isRequired,
  tag: oneOfType([func, string]),
  className: string,
};

FileDownloader.defaultProps = {
  children: 'Download',
  disabled: false,
  onFileDownloadSuccess: () => {},
  tag: Button,
  className: '',
};
